export default __webpack_public_path__ + "static/media/izumrudniy_gorod.debaf1a8.gif";